const Pricing = () => {
    return (
        <div>
            Adipisicing dolore laborum sit ullamco sunt. Officia ex qui cupidatat et quis ad esse non amet ipsum qui. Reprehenderit commodo mollit ad dolore amet esse non ullamco minim. Eiusmod occaecat reprehenderit nisi nisi. Ullamco deserunt exercitation aliquip pariatur labore consequat quis magna minim laboris cillum est. Esse labore eiusmod voluptate Lorem sit veniam ipsum sunt. Ea veniam ipsum est sit magna eu labore duis do.
        </div>
    )
}

export default Pricing
